import { useCallback, useState } from 'react';
import { useScreenInit } from '../useScreenInit.js';

const STORAGE_KEY = 'kd-coffee-table-access';

/** Separate lock from the case studies: unlocking one never unlocks the other. */
export function useCoffeeTableAccess() {
  const screenInit = useScreenInit() as { unlocked?: boolean };
  const [isUnlocked, setIsUnlocked] = useState(() =>
    typeof screenInit.unlocked === 'boolean' ? screenInit.unlocked : readStoredAccess()
  );

  const grantAccess = useCallback(() => {
    setIsUnlocked(true);
    try {
      window.sessionStorage.setItem(STORAGE_KEY, 'granted');
    } catch {
      // Storage unavailable; access lasts for this page view only.
    }
  }, []);

  return { isUnlocked, grantAccess };
}

function readStoredAccess() {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY) === 'granted';
  } catch {
    return false;
  }
}
